import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LoginOtp from "./loginOtp";
import { userLogin, getProfile } from "services/redux/auth/login/action";
import { generateOtp } from "services/redux/auth/loginOtp/action";
import { tryGoogleAuthorisedUserLogin } from "services/redux/auth/login/action";

const mapStateToProps = state => ({
  login_data: state.loginOtp.login_data
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      tryGoogleAuthorisedUserLogin,
      userLogin,
      getProfile,
      generateOtp
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(LoginOtp);
